import { type Brand, make } from 'ts-brand';

type PaginationShape<T> = {

  /** Items on the page. */
  readonly items: readonly T[];

  /** Total count in the store. */
  readonly totalCount: number;

  /** Whether the pagination have next pages. */
  readonly hasNext: boolean;

  /** Whether the pagination have prev pages. */
  readonly hasPrev: boolean;
};

/** Pagination wrapper. */
export type Pagination<T> = Brand<PaginationShape<T>, 'Pagination'>;

/**
 * Pagination constructor.
 * @param data Pagination data.
 */
export const makePagination = <T>(data: PaginationShape<T>): Pagination<T> =>
  make<Pagination<T>>()(data);
